<template>
    <div class="admin-dashboard-currencies">
        <AdminCurrencyList />
    </div>
</template>

<script>
// import AddressNew from "@/components/AddressNew";
// import AddressDetail from "@/components/AddressDetail";
import { mapActions } from "vuex";
import AdminCurrencyList from "../components/AdminCurrencyList";

export default {
    name: "AdminDashboardCurrencies",
    components: {
        AdminCurrencyList
        // AddressNew,
        // AddressDetail
    },
    data() {
        return {
            processing: false,
            showNew: false,
            showDetail: false,
            selectedData: null
        };
    },
    mounted() {
    },
    methods: {
        ...mapActions(["request", "getError"]),
    }
};
</script>
<style scoped>
.el-menu-item.is-active {
    background-color: #005179;
}
.el-menu {
    height: 100%;
    background-color: #005986;
    border-right: solid 1px rgba(255, 255, 255, 0.15);
    width: 200px;
}
.el-menu-item:focus,
.el-menu-item:hover {
    outline: 0;
    background-color: rgba(0, 0, 0, 0.3);
}

.admin-dashboard-permission {
    width: 100%;
    height: 100%;
    display: flex;
}
.admin-dashboard-content{
    flex: 1;
    overflow: auto;
}
.admin-dashboard-permission h2 {
    color: #555;
}
</style>